import {Typography} from '@bonprix/design-system';
import ResponsiveImage from '@core/scripts/templates/ResponsiveImage.jsx';
import React, {Children} from 'react';

function SoldOutRecommendationItem({item, className, multiplePricesText, children, target}) {
    const {price} = item;

    const renderFormerPrice = () =>
        price?.former && (
            <>
                <span className={`${className}__former-price`}>
                    <Typography component="span" variant="body1" color="text-on-background-mid" strikeThrough>
                        {!price.former.uniquePrice && `${multiplePricesText} `}
                        {price.former.value}
                    </Typography>
                </span>
                <span className={`${className}__price-reduction`}>
                    <Typography component="span" variant="body1" color="additional-sale">
                        -{price.current.reduction}%
                    </Typography>
                </span>
            </>
        );

    const currentPrice = (
        <div
            className={`${className}__item-price ${price.current.unknownPrice ? '-unknown' : ''} ${price.former ? '-reduced' : ''}`}
        >
            {!price.current.uniquePrice && <div className={`${className}__multiple-prices`}>{multiplePricesText}</div>}
            <Typography component="span" variant="h4">
                {price.current.value}
            </Typography>
        </div>
    );

    return (
        <div style={{position: 'relative'}}>
            <a href={item.productUrl} className="recommendations__slide-link" target={target}>
                <ResponsiveImage image={item.responsiveImage} alt={item.title} />
                <div>{item.title}</div>
                <div>
                    {currentPrice}
                    {renderFormerPrice()}
                </div>
            </a>
            <div style={{position: 'absolute', top: '8px', right: '8px', cursor: 'pointer'}}>
                {Children.map(children, (child) => React.cloneElement(child, {item}))}
            </div>
        </div>
    );
}

export default SoldOutRecommendationItem;
